export const WEB_PDP_CHECKOUT_TEST = 'web_pdp_checkout_test';
export const PRODUCT_OPTION_TEST_ON = 'product_option_test_on';
